//angular imports
import { ChangeDetectionStrategy, Component, OnDestroy, signal, WritableSignal } from '@angular/core';

//local imports
import { CatalogConstants, ProjectModel } from '@app/catalog';
import { BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger, PresenterType } from '@app/shared';



@PresenterType({
  model: ProjectModel,
  key: 'tileTop'
})
@Component({
  selector: 'project-carousel-item',
  templateUrl: './project-carousel-item.component.html',
  styleUrl: './project-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectCarouselItemComponent implements OnDestroy {
  public data: WritableSignal<ProjectModel> = signal<ProjectModel>(undefined);

  constructor(private messenger: Messenger)
  {}

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    if(!this.data().shouldAddBreadcrumb()) {
      return;
    }
    this.messenger.send(new BreadcrumbItemToggleMessage(item, CatalogConstants.CATALOG));
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
